export enum NavigationSections {
  HowItWorks = '#howitworks',
  Products = '#products',
  Shopify = '#shopify',
  Testimonials = '#testimonials',
  Pricing = '#pricing',
  Plans = '#plans',
  ContactUs = '#contactus',
}
